var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._b({attrs:{"disabled":!_vm.enabled},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({class:{hidden: !_vm.enabled }},on),[_vm._t("default")],2)]}}],null,true)},'v-tooltip',_vm.tooltipOptions,false),[_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.tooltipText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }